import { initSentry, sentryRootErrorHandlers } from '@utils/sentry';
import { initTelemetry } from '@utils/telemetry';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { prefetchLandingPublicData } from '@utils/landingPrefetch';

import '@design-tokens/css-variables.css';
import './index.css';

initSentry();
initTelemetry();

prefetchLandingPublicData();

ReactDOM.createRoot(document.getElementById('root')!, sentryRootErrorHandlers()).render(
  <StrictMode>
    <App />
  </StrictMode>
);
